import { css } from 'styled-components';

export const buttonReset = css`
	margin: 0;
	padding: 0;
	border: none;
	background: none;
	outline: none;
`;
